var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBubblesUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1600,
    zoomAndPan: "magnify",
    viewBox: "0 0 1200 671.999997",
    height: 896,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "341b230a98"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "3ff066c1d1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#341b230a98)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -120,
    width: 1440,
    fill: "#000000",
    y: -67.2,
    height: 806.399996,
    fillOpacity: 0.64
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "4601a3c210"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 131 0 L 136 0 L 136 7 L 131 7 Z M 131 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8a533eab63"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 756,
    y: 0,
    height: 53
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#3ff066c1d1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 223, 0.000000000000009613)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8a533eab63)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4601a3c210)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 132.019531 -2.367188 C 131.316406 -1.496094 131.285156 -1.195312 131.519531 1.921875 C 131.71875 4.972656 132.054688 6.109375 132.65625 6.109375 C 132.792969 6.109375 133.527344 5.105469 134.332031 3.898438 C 135.773438 1.722656 135.773438 1.6875 135.539062 -0.457031 C 135.371094 -2.066406 135.171875 -2.699219 134.703125 -2.933594 C 133.628906 -3.503906 132.757812 -3.304688 132.019531 -2.367188 Z M 132.019531 -2.367188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 486.808594 3.898438 C 486.808594 4.199219 486.976562 4.433594 487.144531 4.433594 C 487.34375 4.433594 487.480469 4.300781 487.480469 4.132812 C 487.480469 3.933594 487.34375 3.699219 487.144531 3.597656 C 486.976562 3.496094 486.808594 3.632812 486.808594 3.898438 Z M 486.808594 3.898438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 351.359375 8.253906 C 351.125 8.855469 352.03125 10.128906 352.667969 10.128906 C 353.136719 10.128906 353.304688 9.257812 352.933594 8.320312 C 352.667969 7.652344 351.59375 7.617188 351.359375 8.253906 Z M 351.359375 8.253906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 405.128906 10.199219 C 404.460938 11.035156 403.386719 13.613281 403.386719 14.519531 C 403.386719 15.859375 404.894531 18.503906 407.039062 20.851562 C 408.75 22.695312 409.117188 22.960938 409.621094 22.660156 C 410.355469 22.222656 410.691406 20.785156 410.757812 17.667969 C 410.824219 15.054688 409.855469 11.636719 408.75 10.632812 C 407.910156 9.863281 405.667969 9.59375 405.128906 10.199219 Z M 405.128906 10.199219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 387.742188 16.964844 C 386.402344 17.566406 385.664062 18.976562 385.429688 21.421875 C 385.265625 23.296875 385.296875 23.429688 386.804688 25.707031 C 388.246094 27.921875 389.785156 29.191406 390.992188 29.226562 C 391.664062 29.226562 393.640625 27.351562 394.042969 26.277344 C 395.078125 23.53125 393.738281 18.4375 391.664062 17.433594 C 389.886719 16.5625 388.914062 16.460938 387.742188 16.964844 Z M 387.742188 16.964844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 494.917969 18.472656 C 494.210938 18.90625 494.546875 20.316406 495.386719 20.449219 C 495.921875 20.515625 496.15625 20.316406 496.324219 19.679688 C 496.660156 18.339844 496.023438 17.769531 494.917969 18.472656 Z M 494.917969 18.472656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 98.117188 20.28125 C 96.878906 21.355469 96.507812 22.222656 96.542969 24.269531 C 96.574219 26.578125 97.546875 30.230469 98.21875 30.667969 C 99.121094 31.238281 100.53125 30.03125 100.53125 28.691406 C 100.53125 28.085938 100.765625 26.847656 101.066406 25.976562 C 102.035156 23.09375 101.199219 19.511719 99.558594 19.511719 C 99.257812 19.511719 98.621094 19.847656 98.117188 20.28125 Z M 98.117188 20.28125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 595.992188 26.109375 C 595.558594 27.285156 596.359375 29.226562 598.070312 31.003906 C 600.28125 33.3125 601.320312 32.109375 600.179688 28.589844 C 599.410156 26.246094 598.539062 25.207031 597.300781 25.207031 C 596.5625 25.207031 596.261719 25.40625 595.992188 26.109375 Z M 595.992188 26.109375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 288.578125 31.003906 C 286.53125 32.140625 285.628906 34.753906 286.265625 37.871094 C 286.566406 39.34375 286.800781 39.847656 287.472656 40.183594 C 289.617188 41.253906 291.324219 40.25 292.09375 37.46875 C 292.664062 35.324219 292.597656 34.652344 291.691406 32.710938 C 290.722656 30.601562 289.984375 30.199219 288.578125 31.003906 Z M 288.578125 31.003906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 374.980469 41.355469 C 374.242188 42.089844 374.507812 43.195312 375.414062 43.429688 C 376.519531 43.699219 376.921875 43.464844 376.921875 42.492188 C 376.921875 41.6875 376.351562 40.953125 375.75 40.953125 C 375.546875 40.953125 375.214844 41.121094 374.980469 41.355469 Z M 374.980469 41.355469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 397.929688 46.246094 C 397.15625 47.082031 397.222656 48.390625 398.027344 49.261719 C 398.765625 50.03125 399.066406 50.097656 400.273438 49.796875 C 401.3125 49.527344 401.648438 47.621094 400.910156 46.480469 C 400.238281 45.476562 398.730469 45.339844 397.929688 46.246094 Z M 397.929688 46.246094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 682.59375 49.832031 C 682.328125 50.5 683.96875 52.140625 684.605469 51.90625 C 685.242188 51.640625 684.90625 50.433594 684.035156 49.832031 C 683.132812 49.195312 682.828125 49.195312 682.59375 49.832031 Z M 682.59375 49.832031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubblesUp);
export default __webpack_public_path__ + "static/media/bubbles-up.bad82fdacbf464b27abf712d48753137.svg";
export { ForwardRef as ReactComponent };